// packages/shared-hooks/src/clients/useArchiveClientContact.ts
//
// `POST /clients/:id/contacts/:contactId/archive` — soft-delete one
// contact. Backend rejects with 409 when the target is the only active
// primary or the last active contact (the aggregate invariant requires
// at least one active contact at all times).
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ClientContactSchema, type ClientContact } from '@magimp/shared';
import { useApiClient } from '../api/context.js';
import { clientsKeys } from './keys.js';

export function useArchiveClientContact(clientId: string, contactId: string) {
  const client = useApiClient();
  const qc = useQueryClient();
  return useMutation<ClientContact, unknown, void>({
    mutationFn: () =>
      client.post<ClientContact>(
        `/clients/${clientId}/contacts/${contactId}/archive`,
        undefined,
        {},
        ClientContactSchema,
      ),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: clientsKeys.detail(clientId) });
      void qc.invalidateQueries({ queryKey: clientsKeys.all });
    },
  });
}
